import React from "react";
import styled from "styled-components";
import Viewmore from "@src/components/Viewmore";
import {
	TextFrame,
	Lead,
	Index,
	IndexNum,
	IndexType,
	StaffInfoCont,
	StaffInfo,
	StaffName,
	StaffPosition,
	StaffRuby,
	Titles,
} from "./styles";

export interface Props {
	voiceNumber: number;
	voiceType: string;
	lead: string;
	staffInfo: {
		name: string;
		position: string;
		ruby: string;
	}[];
	isListItem?: boolean;
	className?: string;
}

const VoiceLead: React.FC<Props> = (props) => {
	const { lead, voiceNumber, voiceType, staffInfo, isListItem, className } =
		props;
	return (
		<TextFrame className={className}>
			<Index>
				<IndexNum>{voiceNumber}</IndexNum>
				<IndexType>{voiceType}</IndexType>
			</Index>
			<Titles>
				<Lead>{lead}</Lead>
				<StaffInfoCont>
					{staffInfo &&
						staffInfo.map((val, index) => (
							<StaffInfo key={index}>
								<StaffPosition>{val.position}</StaffPosition>
								<StaffName>{val.name}</StaffName>
								<StaffRuby>{val.ruby}</StaffRuby>
							</StaffInfo>
						))}
				</StaffInfoCont>
			</Titles>
			{isListItem && <Viewmore />}
		</TextFrame>
	);
};

export default styled(VoiceLead)``;
